import React from 'react'
import DeletedHospital from '../components/Hospitals/DeletedHospital'


export default function HospitalDeleteList() {
    return (
        <div className="layout-body">
            <div className="row">

                <div className="col-md-12">
                    <DeletedHospital />
                </div>
            </div>
        </div>
    )
}
